export const updateLegalProvisionDocumentService =
  (fetch) => async (formData) => {
    try {
      const response = await fetch({
        url: "/api/v1/siniestros-viales/documentos-provisiones-legales",
        method: "put",
        body: formData,
        contentType: "multipart/form-data",
      });

      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
